import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

export function RouteErrorPage() {
	const error = useRouteError();
	const status = isRouteErrorResponse(error) && error.status === 404 ? 404 : 500;
	const title = status === 404 ? 'Page not found' : 'Something went wrong';
	const description = status === 404
		? 'The page you requested is unavailable or has moved.'
		: 'We could not load this page. Please try again or return to chat.';

	return (
		<main className="grid min-h-screen place-items-center bg-slate-950 px-4 text-center text-white">
			<div className="max-w-md">
				<p className="text-7xl font-black tracking-tight text-primary sm:text-8xl">{status}</p>
				<h1 className="mt-4 text-2xl font-semibold">{title}</h1>
				<p className="mt-3 text-sm leading-6 text-slate-300">{description}</p>
				<Link className="mt-6 inline-flex rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" to="/chat">
					Return to chat
				</Link>
			</div>
		</main>
	);
}
